export default __webpack_public_path__ + "static/media/Accident.00a4afc3.png";